import React from 'react';
import Grid from '@mui/material/Grid';

import {
    FooterBottomLogo,
    FooterBottomContainer,
    SimpalsLogo,
    JoblistLogo,
    NineLogo
} from '../footer.style';
import LogoProfi from '../../../assets/FooterLogos/profi.svg';
import LogoJoblist from '../../../assets/FooterLogos/joblist.svg';
import LogoSimpals from '../../../assets/FooterLogos/simpals.svg';
import Logo999 from '../../../assets/FooterLogos/999.svg';
import LogoPrice from '../../../assets/FooterLogos/price.svg';

export const FooterBottom: React.FC<{}> = () => {
    return (
        <FooterBottomContainer container>
            <Grid item md={12/5}>
                <FooterBottomLogo
                    src={LogoProfi}
                    alt='Profi'
                    loading='lazy'
                    onClick={() => window.open('https://profi.md/')}
                />
            </Grid>
            <Grid item md={12/5}>
                <JoblistLogo
                    src={LogoJoblist}                    
                    alt='Joblist'
                    loading='lazy'
                    onClick={() => window.open('https://joblist.md/ru/')}
                />
            </Grid>
            <Grid item md={12/5}>
                <SimpalsLogo
                    src={LogoSimpals}
                    alt='Simpals'
                    loading='lazy'
                    onClick={() => window.open('https://simpals.com/')}
                />
            </Grid>
            <Grid item md={12/5}>
                <NineLogo
                    src={Logo999}
                    alt='999'
                    loading='lazy'
                    onClick={() => window.open('https://999.md/')}
                />
            </Grid>
            <Grid item md={12/5} style={{ textAlign: 'end' }}>
                <FooterBottomLogo
                    src={LogoPrice}
                    alt='Price'
                    loading='lazy'
                    onClick={() => window.open('https://price.md/')}
                />
            </Grid>
        </FooterBottomContainer>
    )
}
